import { faTv } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Group, Stack, Text, Title } from '@mantine/core'
import CircleText from '../../symbols/CircleText'
import classes from '../DeviceSetup.module.css'

interface DeviceSetupInstructionsProps {
  titleText: string
}
function DeviceSetupInstructions({ titleText }: DeviceSetupInstructionsProps) {
  return (
    <Group w={{ base: '100%', sm: '80%' }} gap='xl' wrap='wrap'>
      <Stack flex={{ base: '100%', sm: 3 }} gap={50}>
        <Title order={1} fz={{ base: 24, sm: 42 }} ta='center'>
          {titleText}
        </Title>
        <FontAwesomeIcon icon={faTv} className={classes.tvIcon} />
      </Stack>
      <Stack flex={{ base: '100%', sm: 2 }}>
        <Group>
          <CircleText text='1' />
          <Title size='h2'>Download TV App</Title>
          <Text>
            Download the Hidden Gemz Display app on your smart TV or Amazon Fire
            TV Stick
          </Text>
        </Group>
        <hr style={{ width: '100%' }} />
        <Group>
          <CircleText text='2' />
          <Title size='h2'>Link Device</Title>
          <Text>Link the device to your account using the provided code</Text>
        </Group>
        <hr style={{ width: '100%' }} />

        <Group>
          <CircleText text='3' />
          <Title size='h2'>Complete Screen Details</Title>
          <Text>
            Specify details about your screen including size and pricing
          </Text>
        </Group>
      </Stack>
    </Group>
  )
}

export default DeviceSetupInstructions
